export class DeliveryArea {

    public minAmount: string = '0.00'

    public areaCodes: string=''

    constructor() {

    }

}